// src/com/rtd_term_pos/RtdTermPosView.js
import React from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { AppStyle, AppWord, MapValue } from '../../value/AppConst';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { LabelCell, ViewerCloserBox } from '../../common/TopStyle';
import { mapRequestRepo } from '../../value/AppModel';

const DetailBox = styled(Box)({
    marginTop: '0.5rem', paddingBottom: '0.5rem',
    borderBottom: '1px solid #ccc',
    //borderRadius: '0.5rem',
    backgroundColor: '#fff',
});

const DetailHeader = styled(Box)({
    backgroundColor: '#eee', color: AppStyle.PrimaryRGB, // padding: '0.5rem',
    border: '1px solid #ddd',
    borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
});

/**
 * 차량위치 상세정보.
 * RtdTermPosLine 클릭했을 때 그 컴포넌트 대신에 출력됨.
 */
export default function RtdTermPosView({
    item,
    onClose,
}) {
    
    const onClickGoToMap = () => {
        // set mapRequestRepo data
        const mapData = {
            job: MapValue.Job.ShowTruck,
            info: {
                vehInfoSeq:item.vehInfoSeq,
                vehPlates: item.vehPlates,
                driverName: item.driverName,
                gpsTime: item.gpsTime,
                lat: item.lat,
                lon: item.lon,
                location: item.location,
                posSys: item.posSys,
                direction: item.direction,
                speed: item.speed,
            }
        };
        mapRequestRepo({data: mapData});
    };

    const hasLocation = item.gpsTime && item.lat >= MapValue.Korea.South && item.lon >= MapValue.Korea.West;

    return(
        <DetailBox>
            <DetailHeader>
                차량 최종 위치: {item.vehPlates}
            </DetailHeader>
            <TableContainer component={Paper}>
                <Table size={AppWord.SMALL}>
                    <TableBody>
                        <TableRow>
                            <LabelCell>차량번호</LabelCell>
                            <TableCell>{item.vehPlates}</TableCell>
                            <LabelCell>지도표시명</LabelCell>
                            <TableCell>{item.vehAlias}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>최종보고</LabelCell>
                            <TableCell colSpan={3}>
                                {
                                    hasLocation ? item.gpsTime : '(위치보고 없음)'
                                }
                                {
                                    hasLocation &&
                                    <Button
                                        variant={AppStyle.mui.contained}
                                        size={AppWord.SMALL}
                                        style={{marginLeft: '0.5rem'}}
                                        startIcon={<LocationOnIcon />}
                                        onClick={onClickGoToMap}
                                    >
                                        지도
                                    </Button>

                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>최종위치</LabelCell>
                            <TableCell colSpan={3}>
                                {item.location}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>전원타입</LabelCell>
                            <TableCell>{item.pwrType===1 ? '배터리' : '차량전원'}</TableCell>
                            <LabelCell>위치타입</LabelCell>
                            <TableCell>
                                {
                                    item.posSys==='C'
                                    ?'기지국':item.posSys==='G'
                                    ?'GPS':item.posSys==='L'
                                    ?'과거위치':'기타'
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>속도</LabelCell>
                            <TableCell>시속 {item.speed} Km</TableCell>
                            <LabelCell>누적거리</LabelCell>
                            <TableCell>{item.distKm} Km</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>운송사</LabelCell>
                            <TableCell colSpan={3}>{item.comName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>운전자</LabelCell>
                            <TableCell>{item.driverName}</TableCell>
                            <LabelCell>전화</LabelCell>
                            <TableCell>
                                {
                                    item.driverMobile && item.driverMobile.length > 9 ?
                                    <a href={`tel:${item.driverMobile}`}>
                                    {item.driverMobile}
                                    </a>
                                    : '(없음)'
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>차종</LabelCell>
                            <TableCell colSpan={3}>{item.vehTypeName}-{item.vehTonName}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <ViewerCloserBox onClick={onClose} />
        </DetailBox>
    )
}